module.exports = __webpack_public_path__ + "img/Swift-icon.aecefb7f.svg";